import { catchError, Observable, of, concat, map, take, merge, filter, forkJoin, switchMap, tap } from 'rxjs';
import { selectSearchParameters } from 'features/searchResultsFacets';
import mapDataSlice from './dataSlice';
import { mapBoundariesUpdated$ } from './observables';
import validateIfFetchRequest from '../services/fetchingValidator';
import getMarkersLoaderEndpoints from '../services/markersEndpointSelector';
import processMarkersPayload from '../services/processMarkers';
import extractMapBoundaries from '../services/processMapBoundaries';

const actions = mapDataSlice.actions;

const fetchMarkersResultsEpic = (action$, state$) => {
  // initialFetch$: fires once on startup to load markers from the initial
  // search parameters already in state (no action is dispatched on initial rendering).
  // fetchTriggers$: fires on every subsequent search-parameter action.
  const scheduleIdle = typeof requestIdleCallback !== 'undefined'
    ? (callback) => requestIdleCallback(callback)
    : (callback) => setTimeout(callback, 0);
  const cancelIdle = typeof cancelIdleCallback !== 'undefined'
    ? (id) => cancelIdleCallback(id)
    : (id) => clearTimeout(id);

  const initialFetch$ = new Observable((subscriber) => {
    const id = scheduleIdle(() => {
      subscriber.next();
      subscriber.complete();
    });
    return () => cancelIdle(id);
  }).pipe(
    switchMap(() => state$.pipe(
      map(selectSearchParameters),
      take(1),
      filter(Boolean)
    ))
  );

  const fetchTriggers$ = action$.pipe(
    filter((action) => validateIfFetchRequest(action.type)),
    map(() => selectSearchParameters(state$.value)),
    filter(Boolean)
  );

  return merge(fetchTriggers$, initialFetch$).pipe(
    switchMap((payload) => {
      const apiRequests = getMarkersLoaderEndpoints(payload);

      return concat(
        of(actions.fetchResults()),
        forkJoin(apiRequests).pipe(
          // side-effect to update map boundaries
          tap((data) => mapBoundariesUpdated$.next(extractMapBoundaries(data))),
          map((data) =>
            actions.fetchResultsFulfilled(processMarkersPayload(payload, data))
          ),
          catchError((error) =>
            of(actions.fetchResultsError(error))
          )
        )
      );
    })
  );
};

export default fetchMarkersResultsEpic;